import * as _ from "lodash";
import {User} from "../models/User";
import {CachingCollection} from "./_BaseCollection";

interface UserCollectionOptions {
    organizationId: number
}

export class UserCollection extends CachingCollection<User> {

    organizationId: number;

    url = () => {
        return window.location.origin + '/api/v1/organizations/' + this.organizationId + '/users';
    };

    constructor(initialModels: Object[] | any[], options: UserCollectionOptions) {
        super(initialModels, _.extend({model: User}, options));
        this.organizationId = options.organizationId;

    }

    comparator = (model) => {
        return model.get('name');
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/collections/Users.ts